const resetAnimation = {
    data() {
        return {
            animated: false,
        }
    },
    mounted() {
        this.reset();
    },
    methods: {
        reset() {
            this.$refs.form.reset();
        },
        resetAnimation() {
            this.animated = true;
            setTimeout(() => this.animated = false, 1000);
        },
    }
}

export default resetAnimation
